import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  LinearProgress,
  ButtonGroup,
  Fab,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import BASEURL from "../../../Utils/Baseurl";
import UserDetailsContext from "../../../../context/auth";
import MaterialSelect from "../../../../components/MasterSelect";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import loading from "../../../../assest/images/loading.svg";
import error from "../../../../assest/images/404.svg";
import Swal from "sweetalert2";

const AddWFH = () => {
  const navigate = useNavigate();
  const [id, setId] = useState(null);
  const { user, AccessData } = useContext(UserDetailsContext);
  const [Countdata, setCountdata] = useState(20);
  const [alldisplay, setalldisplay] = useState(false);

  const decodedString = atob(user.teamleader);


  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [wfhData, setwfhData] = useState({
    requestedDate: new Date().toISOString().split("T")[0],
    startDate: "",
    endDate: "",
    totalDays: "",
    reason: "",
    startDateStatus: "unchecked",
    endDateStatus: "unchecked",
    reasonStatus: "unchecked",
  });

  const [originalwfhData, setoriginalwfhData] = useState({
    startDate: "",
    endDate: "",
    totalDays: "",
    reason: "",
  });

  //  useEffect(()=>{
  //   getleavetype();
  //  },[])

  const [leavecount, setleavecount] = useState([]);

  useEffect(() => {
    getleavetype();
  }, []);
  const [WFHCount, setWFHCount] = useState("");
  const getleavetype = async () => {
    let query = `query taken_wfh_by_user_id($id: String!){
  getTakenWfhByUserId(id: $id){
    wfhTaken
  }
}`;
    const encodedId = btoa(user?.id);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query,
          variables: { id: user?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Check and handle the response
      const data = response.data.data.leaveDetailsByMe;
      const result = response.data.data.getTakenWfhByUserId.wfhTaken;
      let count = 20 - result;
      // setWFHCount(result)
      setCountdata(count);
      //   // Format data for dropdown
      // const formattedOptions = data.map((item) => ({
      //   value: item.id,
      //   label: item.leaveType,
      // }));
      // const formatted = data.map((item) => ({
      //   count: item.leaveCount,
      //   leavetype: item.leaveType,
      //   id:item.id
      // }));

      // setleavecount(formatted)
      //   setleaveoptions(formattedOptions);
    } catch (error) {
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  // const [wfhCountData, setwfhCountData] = useState({});

  // useEffect(() => {
  //     const userId = user?.id;
  //     WfhCountDetails(userId);
  // }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const onwfhSubmit = async () => {
    const query = `
          mutation requestforWFH(
            $id: String!
            $startDate: String!
            $endDate: String!
            $teamleader_id: String
            $reason: String!
          ) {
            requestForWfh(input: {
              userId: $id
              startDate: $startDate
              endDate: $endDate
              teamleaderId: $teamleader_id
              reason: $reason
            }) {
              wfhrequest {
                requestedDate
                startDate
                endDate
                reason
                totalDays
                task
                teamApproval
                hrApproval
                lastUpdate
                user {
                  id
                  firstName
                }
              }
            }
          }
        `;

    const { startDate, endDate, reason } = wfhData;
    const encodedId = btoa(user?.id);
    try {
      const response = await fetch(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query,
          variables: {
            id: "VXNlck5vZGU6" + "" + encodedId,
            startDate: startDate,
            endDate: endDate,
            reason: reason,
            teamleader_id: user?.teamleader, // Pass the teamleader id correctly
          },
        }),
      });

      const data = await response.json(); // Parse the JSON response


      if (!response.ok || data.errors) {
        throw new Error(data.errors?.[0]?.message || "Something went wrong");
      }


      let result = data.data.requestForWfh.wfhrequest;

      if (result !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "WFH Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/wfh-management");
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setSnackBar({
        ...snackBar,
        Success: true,
      });
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
  const oneditwfh = async () => {
    setPageState({
      ...pageState,
      state: "submitting",
    });
    const query = `
            mutation UpdateWfhrequest($id: Int!, $input: UpdateWfhInput!) {
                editWFH(id: $id, input: $input) {
                    updatewfhrequest {
                        id
                        startDate
                        endDate
                        totalDays
                        reason
                        teamleaderId
                    }
                }
            }
        `;
    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id,
            input: {
              startDate: wfhData.startDate, // Start date of WFH
              endDate: wfhData.endDate, // End date of WFH
              reason: wfhData.reason, // Reason for WFH
              teamleaderId: wfhData.teamleaderId, // Team leader ID
            },
          },
        }),
      });
      let val = response.data.data.editWFH.updatewfhrequest;
      if (val !== "") {
        navigate("/wfh-management");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "WFH Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }
      if (response.errors) {
        throw new Error(response.errors[0]?.message);
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setSnackBar({
        ...snackBar,
        Success: true,
        message: "WFH request updated successfully!",
      });
    } catch (error) {
      console.error("responseError:", error.message);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeletewfh();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeletewfh = async () => {
    const query = `
          mutation delete($id:String!){
  deleteWFH(id:$id){
		success
  }
}
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      const responseData = response.data;

      // Ensure that the success flag is checked correctly
      if (responseData.data.deleteWFH.success) {
        navigate("/wfh-management");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "WFH Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
      }
    } catch (error) {
      console.error("An error occurred while deleting the wfh:", error);
    }
  };

  const getInitData = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });

    const query = `
         query WFH_ByID($id:String!){
  getWfhById(id:$id){
    id
    requestedDate
      startDate
      endDate
      reason
      totalDays
      task
      teamApproval
      hrApproval
      lastUpdate
      user{
        id
        username
      }
  }
}
        `;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Check if the response contains the data we need
      const wfhrowData = response?.data?.data?.getWfhById;

      // Ensure all fields are correctly set in state

      setwfhData({
        requestedDate: wfhrowData?.requestedDate,
        startDate: wfhrowData?.startDate,
        endDate: wfhrowData?.endDate,
        reason: wfhrowData?.reason,
        totalDays: wfhrowData?.totalDays,
      });

      // Optionally store the original WFH data
      setoriginalwfhData({
        startDate: wfhrowData.startDate,
        endDate: wfhrowData.endDate,
        reason: wfhrowData.reason,
      });

      // Toggle the page view
      setTogglePage({
        ...togglePage,
        view: true,
      });

      // Set the page state to default
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.error("ResponseError:", error);

      // Set page state to error
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleWfhDataChange = (event) => {
    let wfhState = { ...wfhData };
    switch (event.target.name) {
      case "reason":
        {
          const descriptionRegex = new RegExp("^([\\s\\S]{10,100})$");

          if (descriptionRegex.test(event.target.value?.trim())) {
            wfhState[event.target.name + "Status"] = "success";
          } else {
            wfhState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "startDate":
        {
          if (event.target.value?.trim()) {
            wfhState[event.target.name + "Status"] = "success";
          } else {
            wfhState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "endDate":
        {
          if (event.target.value?.trim()) {
            wfhState[event.target.name + "Status"] = "success";
          } else {
            wfhState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;

      default:
        break;
    }
    wfhState[event.target.name] = event.target.value;

    setwfhData(wfhState);
  };

  const handleAddwfh = () => {
    // setPageState({
    //   ...pageState,
    //   state: "submitting",
    // });
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onwfhSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const onDiscardWfh = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setwfhData({
      startDate: originalwfhData.startDate,
      endDate: originalwfhData.endDate,
      reason: originalwfhData.reason,
      totalDays: originalwfhData.totalDays,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      wfhData.startDateStatus === "success" &&
      wfhData.endDateStatus === "success" &&
      wfhData.reasonStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const checkFields = () => {
    let allowSubmit = false;
    if (
      wfhData.startDate === originalwfhData.startDate &&
      wfhData.endDate === originalwfhData.endDate &&
      wfhData.totalDays === originalwfhData.totalDays &&
      wfhData.reason === originalwfhData.reason
    ) {
      allowSubmit = false;
    } else if (wfhData.startDate !== originalwfhData.startDate) {
      if (wfhData.startDateStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (wfhData.endDate !== originalwfhData.endDate) {
      if (wfhData.endDateStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (wfhData.totalDays !== originalwfhData.totalDays) {
      if (wfhData.totalDays === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (wfhData.reason !== originalwfhData.reason) {
      if (wfhData.reasonStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  // const WfhCountDetails = async (id) => {
  //     const query = `  query leaveDetailsUser($id: String!) {
  //                         leaveConfigurationByMe(id: $id) {
  //                             id
  //                             workFromHome
  //                             user {
  //                                 id
  //                                 username
  //                             }
  //                         }
  //                     }`;
  //     try {
  //         setPageState({ ...pageState, loading: true });
  //         const response = await axios.post(BASEURL, {
  //             query: query,
  //             variables: { id },
  //         }, {
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //         });
  //         // Extract wfh count from the response
  //         const WfhCountListdata = response.data.data.leaveConfigurationByMe;
  //         setwfhCountData(WfhCountListdata[0]);
  //         setPageState({ ...pageState, loading: false, state: 'success' });

  //     } catch (error) {
  //         console.error('ResponseError:', error);
  //         setPageState({ ...pageState, loading: false, error: true, message: error.message });
  //     }
  // };
  
const [Visiable ,setVisiable ] = useState(false)

let date1 = new Date(wfhData.startDate);
let date2 = new Date(wfhData.endDate);
let Difference_In_Time = date2.getTime() - date1.getTime();
let Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
let Total_Days = Days + 1;

  useEffect(()=>{
    if (Total_Days < 0) {
      setVisiable(true);  // Set to true if Total_Days is negative
    } else {
      setVisiable(false); // Set to false otherwise
    }
  },[Total_Days])
 

 
 
  const minDate = new Date(new Date().setDate(new Date().getDate() - 7))
  .toISOString()
  .split("T")[0]; // 7 days ago
const maxDate = new Date().toISOString().split("T")[0]; // Today
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Grid container>
        <Grid size={{ xs: 12, sm: 3 }} p={1}>
          <Card>
            <MaterialBox m={4}>
              <MaterialBox
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Fab
                  color="#DFF2EB"
                  sx={{
                    backgroundColor: "#DFF2EB",
                  }}
                >
                  {Countdata}
                </Fab>
              </MaterialBox>

              <MaterialBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingY: 1,
                  borderRadius: "100px",
                  backgroundColor: "#f9f9f9", // light background for text box
                  marginTop: "5%",
                }}
              >
                <MaterialTypography
                  component="label"
                  variant="body2"
                  fontWeight="bold"
                  sx={{
                    fontSize: "1rem",
                    color: "#333333", // Darker color for readability
                  }}
                >
                  Work From Home
                </MaterialTypography>
              </MaterialBox>
            </MaterialBox>
          </Card>
        </Grid>
      </Grid>
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the wfh details for you. This may
                    take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <>
        
          <Card>
            <CardHeader
              title={
                <>
                  {togglePage.view === true || togglePage.edit === true ? (
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                          WFH Detail
                        </MaterialTypography>
                      </Stack>
                      {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            item.component === "EditWFH" && item.can_access
                        ) &&
                        pageState.state !== "submitting" && (
                          <ButtonGroup
                            variant="outlined"
                            aria-label="Loading button group"
                          >
                            <MaterialButton
                              variant="gradient"
                              color="dark"
                              onClick={toggleEdit}
                              startIcon={<EditIcon />}
                            >
                              Edit
                            </MaterialButton>
                            <MaterialButton
                              variant="gradient"
                              color="dark"
                              onClick={AddDelete}
                              startIcon={<DeleteIcon />}
                            >
                              Delete
                            </MaterialButton>
                          </ButtonGroup>
                        )}
                    </Stack>
                  ) : (
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                          Add WFH
                        </MaterialTypography>
                      </Stack>
                    </Stack>
                  )}
                </>
              }
            />
            <CardContent
              sx={{
                minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
              }}
            >
              {pageState.state === "error" && (
                <MaterialBox>
                  <Grid container spacing={1} textAlign="center">
                    <Grid size={{ xs: 12, sm: 12 }}>
                      <img
                        src={error}
                        alt="error"
                        style={{
                          width: "30%",
                        }}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography variant="h6" fontWeight="bold">
                          {pageState.message}
                        </MaterialTypography>
                      </MaterialBox>
                    </Grid>
                  </Grid>
                </MaterialBox>
              )}
              {pageState.state === "default" && !pageState.loading && (
                <MaterialBox>
                  <Grid container spacing={1}>
                    <Grid size={{ xs: 6, sm: 6 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Requested Date <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="requestedDate"
                        value={new Date().toISOString().slice(0, 10)}
                        readOnly
                        error={wfhData.requesteddatestatus === "error"}
                        success={wfhData.requesteddatestatus === "success"}
                        disabled={togglePage.view === true ? true : false}
                      />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Start Date <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="startDate"
                        type="date"
                        onChange={handleWfhDataChange}
                        value={wfhData.startDate}
                        error={wfhData.startDateStatus === "error"}
                        success={wfhData.startDateStatus === "success"}
                        disabled={togglePage.view === true ? true : false}
                        inputProps={{
                          min: new Date(
                            new Date().setDate(new Date().getDate() - 7)
                          ) // 7 days before today
                            .toISOString()
                            .split("T")[0],
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 6, sm: 6 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          End Date <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="endDate"
                        type="date"
                        onChange={handleWfhDataChange}
                        value={wfhData.endDate}
                        error={wfhData.endDateStatus === "error"}
                        success={wfhData.endDateStatus === "success"}
                        disabled={togglePage.view === true ? true : false}
                        // inputProps={{
                        //   min: new Date().toISOString().split("T")[0],
                        // }}
                        inputProps={{
                          min: new Date(new Date().setDate(new Date().getDate() - 7)) // 7 days before today
                            .toISOString()
                            .split("T")[0],
                        }}
                      
                        
                      />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Total Days <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="totalDays"
                        placeholder="Auto Generated"
                        value={Total_Days}
                        disabled
                      />
                      {Total_Days > Countdata && (
                        <FormControl error>
                          <FormHelperText>
                            {`  Available for ${Countdata} days only`}
                          </FormHelperText>
                        </FormControl>
                      )}

                      { Visiable && (
                         <FormControl error>
                         <FormHelperText>
                           Total Days Not Allow in Minus
                         </FormHelperText>
                       </FormControl>
                      )}
                    </Grid>

                    <Grid size={{ xs: 6, sm: 6 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Reason <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="reason"
                        // placeholder="eg. Reason"
                        onChange={handleWfhDataChange}
                        multiline
                        rows={6}
                        value={wfhData.reason}
                        error={wfhData.reasonStatus === "error"}
                        success={wfhData.reasonStatus === "success"}
                        disabled={togglePage.view === true ? true : false}
                      />
                      {wfhData.reasonStatus === "error" && (
                        <FormControl error>
                          <FormHelperText>
                            Reason should be a minimum 10 characters maximum 100
                            characters long.
                          </FormHelperText>
                        </FormControl>
                      )}
                    </Grid>
                  </Grid>
                </MaterialBox>
              )}

              {pageState.state === "submitting" && !pageState.loading && (
                <MaterialBox>
                  <MaterialBox
                    justifyContent="center"
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                    minHeight="50vh"
                  >
                    <MaterialTypography
                      variant="h6"
                      fontWeight="bold"
                      textAlign="center"
                    >
                      Adding your WFH data. This should not take much time.
                    </MaterialTypography>
                    <MaterialBox mt={2}>
                      <img src={loading} alt="loading" width="200px" />
                    </MaterialBox>
                  </MaterialBox>
                </MaterialBox>
              )}
            </CardContent>
            {pageState.state !== "submitting" && (
              <MaterialBox
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                {togglePage.edit === true ? (
                  <>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      disabled={pageState.state === "submitting"}
                      onClick={onDiscardWfh}
                    >
                      Discard
                    </MaterialButton>
                    <MaterialButton
                      sx={{ m: 2 }}
                      variant="gradient"
                      color="dark"
                      disabled={pageState.state === "submitting"}
                      onClick={oneditwfh}
                    >
                      update
                    </MaterialButton>
                  </>
                ) : togglePage.view === false && togglePage.edit === false ? (
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={
                      !checkAllFields() ||
                      pageState.state === "submitting" ||
                      Total_Days > Countdata || Visiable
                    }
                    onClick={handleAddwfh}
                  >
                    Submit
                  </MaterialButton>
                ) : null}
              </MaterialBox>
            )}
            {
              <MaterialSnackbar
                color="success"
                icon={<NotificationsIcon />}
                title="Message"
                content="You have been submitted successfully"
                open={snackBar.Success}
                close={() =>
                  setSnackBar({
                    success: false,
                  })
                }
              />
            }
          </Card>
        </>
      )}
    </DashboardLayout>
  );
};
export default AddWFH;
